import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M23.74,12.25a1.42,1.42,0,0,0-2-.36l-9.47,6.58a.48.48,0,0,1-.54,0L2.26,11.89A1.44,1.44,0,0,0,.62,14.25l9.46,6.58a3.37,3.37,0,0,0,3.84,0l9.46-6.58A1.43,1.43,0,0,0,23.74,12.25Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M.89,7.52l9.47,6.59a2.89,2.89,0,0,0,3.28,0l9.47-6.59a.93.93,0,0,0,.41-.78V3.52A1,1,0,0,0,23,2.67a1,1,0,0,0-1,.07L12.55,9.32a1,1,0,0,1-1.1,0L2,2.74a1,1,0,0,0-1-.07,1,1,0,0,0-.52.85V6.74A.93.93,0,0,0,.89,7.52Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }